module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "playerContainer",
    staticClass: "tengxunyun"
  }, [_c('video', {
    staticClass: "tengxunyun-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (_vm.isShowCover && _vm.backgroundUrl) ? _c('div', {
    staticClass: "video-cover"
  }, [_c('div', {
    staticClass: "video-cover-box"
  }, [_c('img', {
    staticClass: "video-cover-box-img",
    attrs: {
      "src": _vm.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.userInfo) ? _c('div', {
    staticClass: "zhubo-user"
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userInfo.nickName))]), _vm._v(" "), (_vm.data.isPermitMicrophone == 1) ? _c('img', {
    staticClass: "xtzb-item-vioce",
    attrs: {
      "src": require("../../assets/image/zbj_lb_jy_2@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMicrophone()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.isPermitMicrophone == 0) ? _c('img', {
    staticClass: "xtzb-item-vioce",
    attrs: {
      "src": require("../../assets/image/zbj_lb_jy_3@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMicrophone()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_svga) ? _c('playSvga', {
    ref: "svga"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7c374d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tengxunyunzhubo/tengxunyunzhubo.vue
// module id = 1007
// module chunks = 1